<template>
  <v-alert
    v-if="hasError"
    class="error-alert"
    :class="{'error-alert--dismissible': dismissible}"
    type="error"
    :value="visible"
    dense
    :dismissible="dismissible"
    @click="onCloseIconClick"
  >{{ message }}</v-alert>
</template>

<script>
  import ApiErrors from '@/services/ApiErrors/ApiErrors'

  export default {
    name: 'ErrorAlert',
    props: {
      error: {
        required: true,
        validator: value => {
          return ApiErrors || value === null
        }
      },
      dismissible: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: true
      }
    },
    computed: {
      hasError () {
        return this.error != null && this.error.findSystemErrors().length > 0
      },
      message () {
        return (this.hasError)
          ? this.error.findFirstSystemError().message
          : null
      }
    },
    watch: {
      error () {
        if (this.hasError) {
          this.visible = true
        }
      }
    },
    methods: {
      onCloseIconClick () {
        if (this.dismissible) {
          this.visible = false
        }
      }
    }
  }
</script>

<style lang="scss">
  .error-alert {
    &--dismissible {
      cursor: pointer;
    }
  }
</style>
